<ng-container *transloco="let t">
  <app-stats-overlay>
    <div class="flex h-full flex-col gap-3">
      <div class="flex justify-end">
        <div class="flex items-center gap-3">
          <IButton
            [disabled]="isReadOnly"
            [icon]="ICON_TRASH_O"
            (onClick)="deleteProductGroups(selectedRows)"
            color="red"
            label="{{ t('segment-manager.remove_selected_selectedrows_length', { count: selectedRows.length }) }}"
            [hidden]="selectedRows.length === 0"
          ></IButton>
          <IButton
            [disabled]="isReadOnly"
            [icon]="ICON_ADD"
            (onClick)="
              accountMarketplace && createProductGroup(accountMarketplace.accountId, accountMarketplace.marketplace)
            "
            color="main"
            label="{{ t('product-group.create_a_new_product_group') }}"
          />
        </div>
      </div>
      @if (productGroups) {
        <grid-layout
          withExport
          withImport
          (onExport)="exportProductGroups()"
          (onImport)="uploadProductGroups()"
          class="flex-1"
        >
          <ag-grid-angular
            #grid
            class="w-full"
            [gridOptions]="gridOptions"
            [columnDefs]="colDef"
            [rowData]="productGroups"
            (gridReady)="onGridReady($event)"
          />
        </grid-layout>
      }
    </div>
  </app-stats-overlay>
</ng-container>
